import React from "react";
import { Dialog, Portal } from "@ark-ui/react";

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
  title: string;
  wide?: boolean;
  open?: boolean;
}

export function Modal({ children, onClose, title, wide = false, open }: ModalProps) {
  return (
    <Dialog.Root
      {...(open === undefined ? { defaultOpen: true } : { open })}
      onOpenChange={(details) => {
        if (!details.open) onClose();
      }}
      modal
    >
      <Portal>
        <Dialog.Backdrop className="fixed inset-0 z-[140] bg-black/90" />
        <Dialog.Positioner className="fixed inset-0 z-[141] flex items-center justify-center p-4">
          <Dialog.Content className={`modal-content w-full ${wide ? "max-w-[520px]" : "max-w-[400px]"}`}>
            <div className="mb-4 flex items-center justify-between">
              <Dialog.Title className="text-sm uppercase tracking-[3px] text-accent">{title}</Dialog.Title>
              <Dialog.CloseTrigger
                className="flex h-9 w-9 items-center justify-center rounded-sm border-none bg-transparent text-[22px] leading-none text-muted/70 transition-colors hover:text-foreground"
              >
                ×
              </Dialog.CloseTrigger>
            </div>
            {children}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
